var ___EXPOSE_LOADER_IMPORT___ = require("-!../../../../node_modules/imports-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./handlebars.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
var ___EXPOSE_LOADER_IMPORT_MODULE_LOCAL_NAME___ = ___EXPOSE_LOADER_IMPORT___.Handlebars
___EXPOSE_LOADER_GLOBAL_THIS___["Handlebars"] = ___EXPOSE_LOADER_IMPORT_MODULE_LOCAL_NAME___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
